// extracted by mini-css-extract-plugin
module.exports = {"carCard":"eUOT2","shimmerImg":"_3oinb","shimmer":"_2g-N7"};